import { Component } from 'react';
import { RefreshCw, AlertTriangle } from 'lucide-react';

export class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    // A failed lazy-chunk fetch (stale tab after a deploy) lands here
    console.error('App error boundary:', error);
  }

  reload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.error) return this.props.children;

    const isChunkError = /Loading chunk|dynamically imported module|Failed to fetch/i.test(
      this.state.error?.message || ''
    );

    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0B0F17] p-6">
        <div className="w-full max-w-md bg-white border-2 border-slate-900 p-8" data-testid="error-boundary">
          <div className="flex items-center gap-2 text-[#FF5F00] mb-3">
            <AlertTriangle className="w-5 h-5" strokeWidth={2.5} />
            <span className="font-mono text-sm font-bold uppercase tracking-wider">
              {isChunkError ? 'New version available' : 'Something went wrong'}
            </span>
          </div>
          <p className="text-sm text-slate-700 mb-6">
            {isChunkError
              ? 'The app was updated while this tab was open. Reload to get the latest version.'
              : 'An unexpected error interrupted this screen. Reloading usually fixes it.'}
          </p>
          <button onClick={this.reload} className="btn-primary" data-testid="error-boundary-reload">
            <RefreshCw className="w-4 h-4 mr-2" />
            Reload app
          </button>
        </div>
      </div>
    );
  }
}
